import e from "@dialpad/dialtone-tokens/layered/themes/tokens-woodland-colors.css?inline";
//#region themes/woodland.js
var t = {
	brand: {
		css: e,
		name: "woodland"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
